import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBackward } from 'react-icons/fa';

const PageHeader = ({ title, breadcrumbs }) => {

    const navigate = useNavigate();

    return (
        <>
            <div className="text-white py-3" style={{ backgroundColor: '#32366c' }}>
                <div className="container d-flex align-items-center">
                    <FaBackward style={{ marginRight: 15, }} size={25} onClick={() => navigate(-1)} />
                    <h2 className="mb-0 fw-semibold">{title}</h2>
                </div>
            </div>
            <div className="py-2" style={{ backgroundColor: '#f0eceb' }}>
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 small">
                            {breadcrumbs.map((crumb, index) => (
                                <li
                                    key={index}
                                    className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}
                                    aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
                                >
                                    {crumb.href ? <Link to={crumb.href}>{crumb.label}</Link> : crumb.label}
                                </li>
                            ))}
                        </ol>
                    </nav>
                </div>
            </div>
        </>
    )
};

export default PageHeader;